import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {TankCertificate} from "./postCertificate";

export async function getCertificate(certificateId: string) {
    const response = await axios.get<BaseResponse<TankCertificate>>(`/tank/certificate/${certificateId}`)
    return response.data
}
